import React, {useEffect} from "react";
import {
    Container, Content,
} from "./styled";
import {useInjection} from "inversify-react";
import {observer} from "mobx-react";
import {
    ReportTicketAggregateController
} from "@dropDesk/presentation/pages/reports/report_ticket_init/report_ticket_aggregate/controller/report_ticket_aggregate.controller";
import ModalsReportTicketAggregate
    from "@dropDesk/presentation/pages/reports/report_ticket_init/report_ticket_aggregate/ui/modals";
import SearchBar from "@dropDesk/presentation/pages/reports/report_ticket_init/report_ticket_aggregate/ui/search_bar";
import GraphicsReportTicketAggregate
    from "@dropDesk/presentation/pages/reports/report_ticket_init/report_ticket_aggregate/ui/graphics";
import MetricsCards from "@dropDesk/presentation/components/metrics_cards";
import SummaryBanner from "@dropDesk/presentation/components/summary_banner";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import toastMessage from "@dropDesk/utils/toast_message/toast_message";
import {t} from "i18next";
import DropDeskLoading from "@dropDesk/presentation/components/loadings/loading_dropdesk";

const ReportTicketsAggregate = (observer(() => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;
    const controller = useInjection(ReportTicketAggregateController);
    const hasDataInGraphics: boolean = controller.hasData(controller.lineChartClientsAggregate) || controller.hasData(controller.lineChartUsersAggregate) ||
        controller.hasData(controller.lineChartSectorsAggregate) || controller.hasData(controller.lineChartDescriptionsStaticAggregate);

    useEffect(() => {
        controller.initialize();
    }, []);

    const onSuccess = (key: string) => {
        toastMessage.success(t(key));
    }

    return (

        <Container background={colors.onBackground} heightShowingHeaderInfo={appController.heightShowingHeaderInfo}>
            <SearchBar
                getReportTicketsAggregate={controller.getDataReportTicketAggregate}
                loading={controller.loading}
                period={controller.period}
                setPeriod={(dateArray, label) => controller.setPeriod(dateArray, label)}
                hasDataInGraphics={hasDataInGraphics}
                labelPeriodCustom={controller.labelPeriod}
                filterClient={controller.filterClient}
                filterUserClient={controller.filterUserClient}
                filterSector={controller.filterSector}
                filterAttendant={controller.filterAttendant}
                filterDescriptionStatic={controller.filterDescriptionStatic}
                setFilterClient={(f) => controller.setFilterClient(f)}
                setFilterUserClient={(f) => controller.setFilterUserClient(f)}
                setFilterSector={(f) => controller.setFilterSector(f)}
                setFilterAttendant={(f) => controller.setFilterAttendant(f)}
                setFilterDescriptionStatic={(f) => controller.setFilterDescriptionStatic(f)}
                clearEntityFilters={() => controller.clearEntityFilters()}
            />
            <Content>
                {(controller.loading || !!controller.metrics) && (
                    <MetricsCards
                        metrics={controller.metrics}
                        normalization={controller.normalization}
                        withComparative={false}
                        loading={controller.loading && !controller.loadingMessage}
                    />
                )}
                <GraphicsReportTicketAggregate
                    lineChartClientsAggregate={controller.lineChartClientsAggregate}
                    lineChartDescriptionsStaticAggregate={controller.lineChartDescriptionsStaticAggregate}
                    lineChartSectorsAggregate={controller.lineChartSectorsAggregate}
                    lineChartUsersAggregate={controller.lineChartUsersAggregate}
                    texts={controller.texts}
                    hasData={(chart) => controller.hasData(chart)}
                    loading={controller.loading && !controller.loadingMessage}
                />
                {!!controller.texts?.summary && !controller.loading && (
                    <SummaryBanner
                        title="Resumo do período"
                        summary={controller.texts.summary}
                    />
                )}

                <ModalsReportTicketAggregate
                    period={controller.period}
                    loading={controller.loading}
                    exportHtml={() => controller.exportHtml(onSuccess)}
                />
            </Content>
            {(controller.loading && controller.loadingMessage) && <DropDeskLoading
                height={250}
                description={controller.loadingMessage}
            />}
        </Container>
    );
}))
export default ReportTicketsAggregate;
